import CriticalElementRowSkeleton from 'containers/user/critical-elements-monitoring/components/critical-element-row-skeleton';

const ROW_PLACEHOLDER_WIDTH_CLASSES = [
  { name: 'w-[260px]', meta: 'w-[340px]' },
  { name: 'w-[300px]', meta: 'w-[280px]' },
  { name: 'w-[220px]', meta: 'w-[360px]' },
];

const CriticalElementsRosterSkeleton = () => (
  <div role="status" data-testid="critical-elements-roster-skeleton">
    <span className="sr-only">Loading critical elements</span>
    <div className="flex animate-pulse flex-col gap-2" aria-hidden="true">
      {ROW_PLACEHOLDER_WIDTH_CLASSES.map((widths) => (
        <CriticalElementRowSkeleton
          key={widths.name}
          nameWidthClass={widths.name}
          metaWidthClass={widths.meta}
        />
      ))}
    </div>
  </div>
);

export default CriticalElementsRosterSkeleton;
